import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { REPORT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DcrDashboardPage } from '@/features/dashboards/pages/DcrDashboardPage';
import { dcrDashboardListSearchSchema } from '@/features/dashboards/types/dashboard.types';

export const Route = createFileRoute('/_auth/dashboards/dcr/')({
  beforeLoad: () => requirePermission(REPORT_PERMISSIONS.DCR_DASHBOARD_VIEW),
  validateSearch: dcrDashboardListSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DCR Dashboard">
      <Suspense fallback={<PageLoader />}>
        <DcrDashboardPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
